import * as React from 'react';
import {
  getFieldClassNames,
  getFieldStyles,
} from '../../styles/requestDetailsStyles';
import { IThemedProp } from '../../styles/themesUI';

interface IErrorsField {
  showError: boolean;
  errorList: string[];
}

export const ErrorsField = (
  props: IErrorsField & IThemedProp
): React.ReactElement => {
  const { showError, errorList, theme } = props;
  const fieldClassNames = getFieldClassNames(getFieldStyles, {
    theme,
  });
  const fieldStyles = getFieldClassNames(getFieldStyles, {
    theme,
  });
  // return null if errorList is empty or errorList has been disabled
  if (!showError || !errorList || errorList.length === 0) {
    return null;
  }
  return (
    <>
      {errorList.map((errorMessage: string, index: number) => {
        return (
          <div aria-live="assertive"
               arial-labelledby="errorsFieldAlert"
               className={fieldClassNames.fieldSection}
               key={`${index}-${errorMessage}`}>
            <div id="errorsFieldAlert"
                 role="alert" aria-label={errorMessage} className={fieldStyles.fieldInputInvalidMessage}>
              {errorMessage}
            </div>
          </div>
        );
      })}
    </>
  );
};
